<template>
    <div class="col-12">
        <v-card>
            <v-app-bar dark class="period-toolbar" :style="'background-color:' + primaryColor" height="auto">
                <div class="d-flex justify-content-between w-100">
                    <div class="mt-auto mb-auto cmaj-title d-flex justify-content-between w-100">

                        <div class="d-flex gap-20">
                            <div>
                                Du <h4 class="text-white">{{ formatDate(period.valid_from, false) }}</h4>
                            </div>
                            <div>
                                au <h4 class="text-white">{{ formatDate(period.valid_through, false) }}</h4>
                            </div>
                        </div>

                        <div class="d-flex gap-20" v-if="!readOnly">
                            <div>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" icon @click="prepareEdit" class="edit-btn">
                                            <v-icon dense>edit</v-icon>
                                        </v-btn>
                                    </template>
                                    <div>Modifier</div>
                                </v-tooltip>
                            </div>

                            <div>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" icon @click="confirmDelete" class="close-btn">
                                            <v-icon dense>close</v-icon>
                                        </v-btn>
                                    </template>
                                    <div>Supprimer</div>
                                </v-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </v-app-bar>

            <v-card-text style="font-size: 16px">
                <div v-if="period.prices.length">

                    <div v-for="price in period.prices" v-if="price.element !== null"
                         class="row border-bottom price-item">
                        <div class="col-3">
                            {{ price.element.label }}
                        </div>
                        <div class="col-3">
                            <div v-if="price.mode === 'MIN_MAX'">
                                De {{ price.min }}&nbsp;{{ period.currency.label }} à
                                {{ price.max }}&nbsp;{{ period.currency.label }}
                            </div>
                            <div v-else-if="price.mode === 'FROM'">
                                À partir de {{ price.min }}&nbsp;{{ period.currency.label }}
                            </div>
                            <div v-else-if="price.mode === 'UNIQUE'">
                                {{ price.min }}&nbsp;{{ period.currency.label }}
                            </div>
                        </div>
                        <div class="col">
                            {{ price.detail }}
                        </div>
                    </div>
                </div>
                <div v-else><b>Aucun tarif renseigné</b></div>
            </v-card-text>

            <confirm ref="confirm"></confirm>
        </v-card>
    </div>
</template>

<script>
import {mapMutations, mapState} from "vuex"
import Confirm from "../../../../tools/Confirm.vue"

export default {
    name: "PricePeriodTable",
    components: {Confirm},
    props: ['period', 'index'],
    methods: {
        ...mapMutations('web_form', ['setAddPricePeriodDialog', 'setCurrentPricePeriod', "setPricesTabDirty",]),
        confirmDelete() {
            let period = this.provider.price_periods[this.index]

            this.$refs.confirm.open('Attention',
                'Vous allez supprimer les tarifs saisies pour la période du ' + this.formatDate(period.valid_from, false) +
                ' au ' + this.formatDate(period.valid_through, false) + '. ' +
                'Êtes-vous sûr de vouloir supprimer cette période ?',
                { color: 'red', confirmColor: 'red', cancelColor: '#0b697e' }).
            then((confirm) => {
                if (confirm) {
                    this.provider.price_periods.splice(this.index, 1)
                    this.setPricesTabDirty(true)
                }
            })
        },
        prepareEdit() {
            this.setCurrentPricePeriod(JSON.parse(JSON.stringify(this.period)))
            this.setAddPricePeriodDialog(true)
        },
    },
    computed: {
        ...mapState('web_form', ['provider', 'readOnly',]),
        ...mapState("webFormStyle", ['primaryColor']),
    }
}
</script>